import { z } from 'zod';
import {
  keyValueSchema,
  locationSchema,
  placementStatesSchema,
  workerEmploymentTypeSchema,
} from '../zod-schemas/schema';

const requirementsSchema = z.object({
  skills: z.array(keyValueSchema),
  language: z.array(keyValueSchema),
  apparel: z.array(keyValueSchema),
});

export const projectDetailSchema = z.object({
  id: z.string(),
  weekHourVolume: z.number(),
  maxPlacements: z.number(),
  startDate: z.string(),
  endDate: z.string(),
  placements: z.array(
    z.object({
      flexWorker: z.object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        infix: z.string(),
        fullName: z.string(),
        email: z.string(),
        phone: z.string(),
        imageUrl: z.string(),
        employmentType: workerEmploymentTypeSchema.nullable(),
      }),
      id: z.string(),
      state: placementStatesSchema,
    })
  ),
  location: locationSchema,
  name: z.string(),
  department: z.object({
    id: z.string(),
    name: z.string(),
  }),
  applicantsCount: z.number(),
  certificates: z.array(z.string()),
  flexPools: z.array(z.string()),
  freelanceProperties: z
    .object({
      hourlyRateCents: z.number(),
      mutableUntilMinutes: z.number(),
    })
    .optional(),
  tempWorkProperties: z
    .object({
      grossHourlyRateCents: z.number(),
      cla: z.string(),
    })
    .optional(),
  descriptionShort: z.string(),
  descriptionLong: z.string(),
  descriptionLawRequirements: z.string(),
  contactName: z.string(),
  contactPhoneNumber: z.string(),
  requirements: requirementsSchema,
  companyGrossHourlyRate: z.number().optional(),
});

export type ProjectDetail = z.infer<typeof projectDetailSchema>;
